import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'

import MultiSelectWithSearch from 'components/Shared/MultiSelectWithSearch'
import { AdminUITheme } from 'types/AdminUiThemeMui'
import { InitialParticipantTypes } from 'types/ReportingFilterBuilderContext'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { trackActions } from 'containers/Helper'
import { FilterItem } from 'types/FilterBuilder'
import { updateFilter } from 'redux/slices/FilterBuilder'
import { PARTICIPANT_TYPES_FILTER } from 'lib/GlobalConstants'

type Props = {
  item: FilterItem
  index: number
  isAutoFocusEnabled: boolean
}

const ParticipantTypes = (props: Props) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const {
    item: { value },
    index,
    isAutoFocusEnabled,
  } = props
  const {
    features: { features: currentFeatures = [] } = {},
    user: { user: currentUser = {} } = {},
  } = useAppSelector((state) => state)

  const [fetchedOptions, setFetchedOptions] = useState<InitialParticipantTypes>(
    [],
  )
  const [selectedOptions, setSelectedOptions] =
    useState<InitialParticipantTypes>([])

  const updateLang = (value: any = []) =>
    value?.map((item: any) => {
      return { ...item, name: `${t(`filters.participantTypes.${item.key}`)}` }
    })

  const isOptionEqualToValue = (
    option: { key: string },
    value: { key: string },
  ) => {
    return option.key === value.key
  }

  const handleFilterByParticipantTypes = (value: InitialParticipantTypes) => {
    dispatch(
      updateFilter({
        item: { value },
        index,
      }),
    )

    value.length > 0 &&
      trackActions(
        `Selected Participant type filter option - ${
          value[value.length - 1].name
        }`,
        {
          featureName: 'Overview dashboard filters',
          sectionName: 'Overview (Home) Dashboard page',
          ...currentFeatures?.['segment_analytics_admin']?.enabled,
        },
      )
  }

  const theme: AdminUITheme = useTheme()

  useEffect(() => {
    const result: InitialParticipantTypes = PARTICIPANT_TYPES_FILTER.map(
      (item: string, index: number) => {
        return {
          id: ++index,
          key: item,
          name: `${t(`filters.participantTypes.${item}`)}`,
        }
      },
    )
    setFetchedOptions(result)
  }, [currentUser])

  useEffect(() => {
    setSelectedOptions(updateLang(value))
  }, [currentUser, value])

  useEffect(() => {
    trackActions('Clicked on Participant type filter option', {
      featureName: 'Overview dashboard filters',
      sectionName: 'Overview (Home) Dashboard page',
      ...currentFeatures?.['segment_analytics_admin']?.enabled,
    })
  }, [])

  return (
    <MultiSelectWithSearch
      style={theme.GenericTheme.filterWrapperWidth}
      isOptionEqualToValue={isOptionEqualToValue}
      selectedValues={selectedOptions}
      options={fetchedOptions}
      handleOnChange={handleFilterByParticipantTypes}
      defaultOpen={isAutoFocusEnabled}
      optionKey="name"
      dataTestId="user_type"
      labelKey="filters.participantType.label"
      placeholderKey="filters.search"
    />
  )
}

export default ParticipantTypes
